export default __webpack_public_path__ + "static/office-cd0e351c2c92da860a4e8d74fb8b53b2.jpg";